import { useTranslation } from "react-i18next";

interface InvalidOrderLinkProps {
  onCreateNewSong: () => void;
}

/**
 * Shown when the link carries no usable docId. Without this the pages render a
 * complete-looking order with every value blank.
 */
export default function InvalidOrderLink({
  onCreateNewSong,
}: InvalidOrderLinkProps) {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex min-h-full w-full max-w-[520px] flex-col items-center justify-center px-4 py-16 text-center">
      <h1 className="text-[24px] font-bold leading-[1.2] tracking-[0.4px] text-[#16283d] sm:text-[28px] dark:text-[#fdfdfd]">
        {t("songOrder.invalidLink.title")}
      </h1>
      <p className="mt-3 text-[15px] font-normal leading-[1.45] text-[#687585] dark:text-[#a1a7b0]">
        {t("songOrder.invalidLink.body")}
      </p>
      <button
        type="button"
        id="invalidLinkCreateNewSong"
        onClick={onCreateNewSong}
        className="primary-cta mt-8 px-10 py-3.5"
      >
        {t("songOrder.actions.createNewSong")}
      </button>
    </div>
  );
}
